import { defineMessages } from 'react-intl';

export default defineMessages({
  trial: 'Okres próbny',
  active: 'Aktywna',
  inactive: 'Nieaktywna',
  lackOfTools: 'Brak narzędzi',
});
